/* eslint-disable max-len */

const STUDENT_STORAGE_DATA = [
	{
		heading: "Storage for college students",
		description:
			"Every year, college students move in and out of dorm rooms. While plenty of students can do this easily since their parents or guardians live close to the colleges or universities they attend, many attend out-of-state institutions, which can make this move a bit more difficult. That's why a lot of out-of-state students utilize self storage to make moving in and out of their dorm a breeze."
	},
	{
		subHeadings: [
			{
				title: "Self storage vs. moving everything home for summer break",
				desc: "Since most campus residence halls don't allow students to keep their belongings at school over the summer, students are faced with either finding a place to store everything or moving their belongings back home for the summer. Renting a storage unit near campus can give you a place to store your belongings over the summer so you don't have to move it home just to move it back again the next fall.",
				desc2: "Let's compare using a storage unit to moving everything home over your summer break.",
				level: 3
			},
		],
		points: [
			{
				title: "Cost ",
				desc: "- For those who have a lot of stuff and a long trip home, a car may not cut it. If you have large furniture to take home, you could end up having to rent a moving truck just to fit it all in a single trip. Moving trucks rentals are often based on distance but could easily cost around $100 one way. You can save yourself a lot of money and hassle by renting a small storage unit for the summer."
			},
			{
				title: "Convenience ",
				desc: "- Moving everything home just to move it all back to school a few short months later is the opposite of convenience. Leaving dorm belongings in a storage unit near campus is a much more convenient option."
			}
		],
	},
	{
		subHeadings: [
			{
				title: "College student discounts",
				descLink: {
					contentBefore:
						"College students are notoriously frugal, so they know a good deal when they see one. Many storage facilities on Storage.com offer discounts specifically for students to help them afford a storage unit. If you're looking for storage near campus and want to save a few bucks, call us at  ",
					linkText: "(833) 448-1067",
					phone: {
						// temp until we implement sparephone
						formattedNumber: "833-448-1067",
						number: "8334481067"
					},
					contentAfter:
						", and we'll help point you toward facilities in your area offering student discounts. Most facilities will require a current student ID upon arrival."
				},
				level: 3
			}
		]
	},
	{
		subHeadings: [
			{
				title: "Other self storage uses for college students",
				desc: "While many students use self storage to make moving in and out of their dorm a lot easier, there are several other ways that a storage unit can assist college students.",
				level: 3
			}
		],
		points: [
			{
				title: "Studying Abroad ",
				desc: "- Studying abroad is an amazing experience that many college students take advantage of while going to school. Since you'll be gone for a semester or more, you may need a place to keep your things. Self storage can be an excellent resource."
			},
			{
				title: "Studying in Large/Expensive Cities ",
				desc: "- Some universities and colleges aren't located in small college towns. For students who are attending school in larger or more expensive cities, it's easy to save space and money on housing by using self storage. Instead of paying more for a larger place, you can use a storage unit to expand your living space."
			},
			{
				title: "In-Between Leases ",
				desc: "- Some college students choose to live near their campus all year while working or interning over their summer breaks. If you're renting a place off-campus and your lease is coming to an end, self storage can bridge the gap between leases."
			}
		],
		level: 3
	},
	{
		subHeadings: [
			{
				title: "Appropriate storage unit sizes for college students",
				desc: "Most college students won't need a storage unit the size of a garage, but how big is big enough? While it depends on what you plan to store, there are two sizes that are ideal for most college students:",
				level: 3
			}
		],
		points: [
			{
				title: "5x5 ",
				desc: "- A 5x5 storage unit is a lot like a large closet and can fit more than you would think. This would be perfect for a single student who doesn't have large furniture to store. Even if you have a couch longer than five feet, you could still fit it if you stood it upright."
			},
			{
				title: "5x10 ",
				desc: "- A 5x10 storage unit will give you more room for larger furniture, like a long sofa and a chair, as well as room for all of your other belongings. This makes the 5x10 storage unit a great option for students who are moving out of an apartment for the summer."
			}
		]
	},
	{
		subHeadings: [
			{
				title: "How to save money using self storage",
				desc: "As a college student, you learn how to be thrifty pretty quick. When it comes to using self storage, there are more than a few ways you can save money.",
				level: 3
			}
		],
		points: [
			{
				desc: "Sharing a storage unit with a roommate or friend can allow you to split the cost in half, saving you a good chunk of change."
			},
			{
				desc: "Storage units come with several amenities these days, and they all add on to the cost of your unit. Make sure you don't get a storage unit with unnecessary amenities, like climate control, if your school is in a temperate location."
			},
			{
				desc: "While it would be great to find a storage unit that's close to campus, you may be able to find a cheaper location elsewhere. Shop around for the cheapest price in order to cut your costs."
			},
			{
				desc: "If you're going to need a moving truck, look for a storage facility that offers them free of charge to customers. There are many storage facilities that offer this, so take advantage of it when applicable."
			}
		]
	}
];

export { STUDENT_STORAGE_DATA };
